const destructive = "_destructive_1pz9o_95";
const styles = {
  "icon-button": "_icon-button_1pz9o_8",
  "no-background": "_no-background_1pz9o_42",
  destructive
};
export {
  styles as default,
  destructive
};
//# sourceMappingURL=IconButton.module.css.js.map
